import { render, staticRenderFns } from "./TenantsList.vue?vue&type=template&id=0b57bdfa&scoped=true"
import script from "./TenantsList.vue?vue&type=script&lang=js"
export * from "./TenantsList.vue?vue&type=script&lang=js"
import style0 from "./TenantsList.vue?vue&type=style&index=0&id=0b57bdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57bdfa",
  null
  
)

export default component.exports